import React, { useEffect, useState } from 'react';
import { getReservationList } from '../../../services/OtherService';
import Pagination from '../../constant/Pagination';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import TableLoaderEffect from '../../constant/TableLoader';
import DebounceSearchInput from '../../constant/DebounceSearchInput';
import CreateReservationModal from './CreateReservationModal.jsx';
import { RequisitionStatusBadge } from "../Requisition"
import Select from 'react-select';

const statusOtpion = [
    { value: 'PENDING', label: 'PENDING' },
    { value: 'FULFILLED', label: 'FULFILLED' },
    { value: 'CANCELLED', label: 'CANCELLED' },
]
const ReservationPage = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const [status, setStatus] = useState(null);
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const recordsPage = 10;

    useEffect(() => {
        fetchList(currentPage, searchQuery, status?.value || '');
    }, [currentPage, searchQuery, status]);

    const fetchList = (page, query = '', status = '') => {
        setIsLoading(true);
        getReservationList({ page, page_size: recordsPage, query, status }).then((resp) => {
            setData(resp.data.data);
            setTotal(resp.data.total);
            setIsLoading(false);
        }).catch((err) => {
            toast.error(err?.response?.data?.message || 'Error fetching requisitions');
            setIsLoading(false);
        });
    };

    const handlePagination = (page) => {
        const newPage = page.selected + 1;
        setCurrentPage(newPage);
    };

    const handleSearchChange = (value) => {
        setSearchQuery(value);
        setCurrentPage(1)
    };

    const handleStausChange = (data) => {
        setStatus(data || null);
        setCurrentPage(1);
    }

    const handleAfterSubmit = (data) => {
        if (data) {
            setData(prevData => [data, ...prevData]);
            setTotal(prevTotal => prevTotal + 1);
        }
    }


    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-body p-0">
                            <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center p-3">
                                <h4 className="mb-0">Reservations</h4>
                                <div className='d-flex align-items-center flex-wrap gap-3'>
                                    <Select
                                        value={status}
                                        onChange={(data) => handleStausChange(data)}
                                        placeholder={"Select Status"}
                                        isClearable={true}
                                        options={statusOtpion}
                                        id={'status'}
                                        className='react-select'
                                        classNamePrefix='select'
                                    />

                                    <div className='form-group'>
                                        <DebounceSearchInput handleSearchChange={handleSearchChange} />
                                    </div>
                                    <CreateReservationModal onAfterSubmit={handleAfterSubmit} />
                                </div>
                            </div>

                            <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                    <thead>
                                        <tr>
                                            <th>Reference No</th>
                                            <th>Type</th>
                                            <th>Reserved By</th>
                                            <th>Status</th>
                                            <th>Reserved At</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {isLoading ? <TableLoaderEffect colLength={4} /> : data.map((res, index) => (
                                            <tr key={index}>
                                                <td><Link className='fw-semibold text-primary' to={`/reservation/${res.id}`}>{res.reference_no}</Link></td>
                                                <td>{res.reservation_type}</td>
                                                <td>{res.reserved_by?.name || ""}</td>
                                                <td><RequisitionStatusBadge status={res.status} /></td>
                                                <td>{res.created_at}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                {!isLoading && <Pagination
                                    currentPage={currentPage}
                                    recordsPage={recordsPage}
                                    dataLength={total}
                                    handlePagination={handlePagination}
                                />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReservationPage;
